import "./style.scss";

import { DocumentBasylic, DocumentPreviewNumberType, isDocumentBasylic } from "shared/types/types";

import { FC } from "react";
import ToggleIdNumber from "../ToggleIdNumber";
import { formatTypeDocument } from "../../assets/functions/";
import NationalityBadge from "../NationalityBadge";

type DocumentPreviewProps = {
    document: DocumentBasylic | DocumentPreviewNumberType;
    type?: string;
    showNumber?: boolean;
};

const DocumentPreview: FC<DocumentPreviewProps> = ({ document, type = "default", showNumber = false }) => {
    const style = type === "lost_or_sloten" || type === "error" || type === "fraude" ? "error" : "";
    return (
        <div className={`DocumentPreview ${style}`}>
            {document && (
                <>
                    {isDocumentBasylic(document) ? (
                        <>
                            <div className="DocumentPreview__header">
                                <h4 className="DocumentPreview__header__title">{formatTypeDocument(document.typeDocument)}</h4>
                                <ToggleIdNumber number={document?.numeroDocument}  />
                            </div>
                            <div className="DocumentPreview__content">
                                <div>
                                    <p>
                                        {document?.prenom} {document?.nom}, {document?.sexe}
                                    </p>
                                    <div className="row gap-1">
                                        <div className="col-sm-6">
                                            <p className="label">Date de naissance:</p>
                                            <p>{document?.dateNaissance}</p>
                                        </div>
                                    </div>
                                    <div className="row gap-1">
                                        {document?.dateDelivrance && (
                                            <div className="col-6">
                                                <p className="label">Date de delivrance:</p>
                                                <p>{document?.dateDelivrance}</p>
                                            </div>
                                        )}
                                        {document?.dateExpiration && (
                                            <div className="col-6">
                                                <p className="label">Date d'expiration:</p>
                                                <p>{document?.dateExpiration}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="DocumentPreview__nationality">
                                    <NationalityBadge nationality={document?.paysNaissance} />
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="DocumentPreview__header">
                            <div>
                                <h4 className="DocumentPreview__header__title">{formatTypeDocument(document.typeDocument)}</h4>
                                <ToggleIdNumber number={document?.numeroDocument} showNumber={showNumber} />
                            </div>

                            <div className="DocumentPreview__nationality">
                                <NationalityBadge nationality={document?.country} />
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default DocumentPreview;
